import EditResumeTitleModal from './EditResumeTitleModal'

export default EditResumeTitleModal
